<template>
  <a-modal
    class="detail-modal"
    title="Ünvan təyini"
    v-model="modalVisible"
    :footer="null"
    centered
  >
    <a-row>
      <a-col :span="6" class="ant-form-item-label">
        <label class="required">Küçə</label>
      </a-col>
      <a-col :span="14">
        <a-auto-complete
          @search="searchStreets"
          allowClear
          v-model="streetKey"
          style="width: 100%"
        >
          <template slot="dataSource">
            <a-select-option v-for="x in filterStreets" :key="'street' + x.id"
              >{{ x.name }}
            </a-select-option>
          </template>
        </a-auto-complete>
        <a-spin :spinning="streetSpin" class="txt-search">
          <a-icon
            slot="indicator"
            type="loading"
            style="font-size: 24px"
            spin
          />
        </a-spin>
        <p class="error">{{ streetError }}</p>
      </a-col>
    </a-row>

    <a-row style="margin-bottom: 10px">
      <a-col :span="6" class="ant-form-item-label">
        <label class="required">Ünvan təsviri</label>
      </a-col>
      <a-col :span="14">
        <textarea v-model="address" class="ant-input pr-form"></textarea>
      </a-col>

      <p class="error">{{ addresssError }}</p>
    </a-row>

    <g-map
      v-if="problem"
      :latitude="problem.latitude"
      :longitude="problem.longitude"
    ></g-map>

    <div style="position: relative; height: 40px; margin-top: 10px">
      <a-button
        style="position: absolute; right: 0"
        type="primary"
        :loading="submitLoading"
        @click="saveAddress"
        >Saxla</a-button
      >
    </div>
  </a-modal>
</template>

<script>
import { URL, apiCall } from "@/utils/api";
import mixin from "@/mixins/index";
import Map from "@/components/partials/Map/index";
export default {
  name: "AddressModal",
  props: {
    problem: Object,
    visible: Boolean,
  },
  mixins: [mixin],
  components: {
    "g-map": Map,
  },
  data() {
    return {
      modalVisible: false,
      filterStreets: [],
      streetsAll: [],
      streetError: "",
      addresssError: "",
      strSearchTimeout: null,
      streetSpin: false,
      streetKey: null,
      address: null,
      submitLoading: false,
    };
  },
  methods: {
    searchStreets(value) {
      // let smallValue = value.toLowerCase();
      clearTimeout(this.strSearchTimeout);
      this.strSearchTimeout = setTimeout(() => {
        this.streetSpin = true;
        this.getStreets(null, value, this.problem.executive.id);
      }, 2000);
    },
    saveAddress() {
      let streetId = Number(this.streetKey.replace("street", ""));
      if (isNaN(streetId)) {
        this.$message.error("Zəhmət olmasa küçəni siyahıdan seçin");
        return;
      }
      apiCall({
        url:
          URL[process.env.NODE_ENV].service_api +
          "problems/" +
          this.problem.id +
          "/address",
        method: "POST",
        data: {
          streetId: this.streetKey.replace("street", ""),
          address: this.address,
        },
      })
        .then((response) => {
          if (!response.data.error) {
            this.$emit("success");
          } else this.$message.error(response.data.error.message);
        })
        .catch((err) => {
          this.$message.error("Xəta baş verdi");
          console.log(err);
        });
    },
  },
  watch: {
    visible: function (newValue, oldValue) {
      this.modalVisible = this.visible;
    },
    modalVisible: function () {
      if (!this.modalVisible) {
        this.modalVisible = false;
        this.$emit("after-close");
      }
    },
  },
  created() {
    this.modalVisible = this.visible;
  },
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
